import { useState, useEffect } from "react";
import App from "./App";
import { LandingPage } from "./LandingPage";

type Page = "landing" | "demo";

export function Root() {
  const [page, setPage] = useState<Page>(() =>
    window.location.hash === "#demo" ? "demo" : "landing",
  );

  useEffect(() => {
    const onHash = () => {
      setPage(window.location.hash === "#demo" ? "demo" : "landing");
      window.scrollTo(0, 0);
    };
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  return page === "demo" ? <App /> : <LandingPage />;
}
